<div class="">
  <div class="">
    <div class="card">
      <div class="card-body">
        <div class="card-title">Edit Profile</div>
        <div class="form-group">
          <label class="form-label">Username</label>
          <input type="text" [value]="profile?.username" />
        </div>
        <div class="form-group">
          <label class="form-label">Email Address</label>
          <input
            formControlName="email"
            id="email"
            type="text"
            class="form-control"
            placeholder="Email ID"
            required
          />
        </div>
        <div class="form-group">
          <label class="form-label">Display Name</label>
          <input
            formControlName="name"
            id="name"
            type="text"
            class="form-control"
            placeholder="Name"
            required
          />
        </div>
        <div class="form-footer">
          <button class="btn btn-primary btn-block" (click)="onSave()">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
